import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useProjectSettingStore = defineStore('projectSettings', () => {
  const mobileIframeRef = ref<HTMLIFrameElement | null>(null)
  const desktopIframeRef = ref<HTMLIFrameElement | null>(null)
  const integrationIframeRef = ref<HTMLIFrameElement | null>(null)
  const isWidgetRedrawRequired = ref<boolean>(true)

  return {
    mobileIframeRef,
    desktopIframeRef,
    integrationIframeRef,
    isWidgetRedrawRequired
  }
})
